.heading{line-height:40px;height:41px}
/*# sourceMappingURL=product-types.component-AYI5EXDU.css.map */
